import type {
  AnswerData,
  Certificate,
  GenerateNewTest,
  RecordAnswerData,
  RecordList,
  TestType
} from '@/models/interface/newToeic';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class ToeicService extends ApiFactory {
  constructor() {
    super('ToeicNew');
  }

  /**
   * 取得新多益測驗類型
   * @returns
   */
  getTestTypes(): Promise<ApiDataResponse<TestType[]>> {
    return super.get('TestTypes');
  }

  /**
   * 取得題目內容
   * 1. 傳 testTypeId, isTimerOpen 為新考卷
   * 2. 傳 testId 為已經存進db的考卷
   * 3. 都為空 為存進redis內的考卷
   * @param testTypeId 考卷類別
   * @param isTimerOpen 是否開啟計時
   * @param testId 取得已送出的考卷
   * @returns
   */
  generateNewTest(
    testTypeId?: number,
    isTimerOpen?: boolean,
    testId?: number
  ): Promise<ApiDataResponse<GenerateNewTest>> {
    const params = new URLSearchParams();

    if (testTypeId !== undefined) {
      params.append('testTypeId', testTypeId.toString());
    }
    if (isTimerOpen !== undefined) {
      params.append('isTimerOpen', isTimerOpen.toString());
    }
    if (testId !== undefined) {
      params.append('testId', testId.toString());
    }
    return super.get(`GenerateNewTest?${params}`);
  }

  /**
   * 取得考卷是否存在Redis
   * @returns
   */
  getToeicExist(): Promise<ApiDataResponse<boolean>> {
    return super.get('GetToeicExist');
  }

  /**
   * 儲存答案至Redis
   * @param params
   * @returns
   */
  saveAnswer(params: AnswerData[]): Promise<ApiDataResponse<boolean>> {
    return super.put('SaveAnswer', params);
  }

  /**
   * 取得Redis作答記錄
   * @returns
   */
  getAnswer(): Promise<ApiDataResponse<AnswerData[]>> {
    return super.get('GetAnswer');
  }

  /**
   * 送出考卷
   * @returns testId
   */
  submitAnswer(): Promise<ApiDataResponse<number>> {
    return super.post('SubmitAnswer', {});
  }

  /**
   * 取得證書
   * @param testId
   * @returns
   */
  getCertificate(testId?: number): Promise<ApiDataResponse<Certificate>> {
    return super.get(`GetCertificate${testId && '?testId=' + testId}`);
  }

  /**
   * 取得過往考卷資料
   * @param testId
   * @returns
   */
  getRecordAnswer(testId?: number): Promise<ApiDataResponse<RecordAnswerData[]>> {
    return super.get(`GetRecordAnswer${testId && '?testId=' + testId}`);
  }

  /**
   * 作答記錄
   * @param pageNumber
   * @param pageSize
   * @returns
   */
  getRecordList(
    pageNumber?: number,
    pageSize?: number
  ): Promise<ApiDataResponse<{ data: RecordList[]; lastPage: number; total: number }>> {
    const params = new URLSearchParams();

    if (pageNumber !== undefined) {
      params.append('pageNumber', pageNumber.toString());
    }
    if (pageSize !== undefined) {
      params.append('pageSize', pageSize.toString());
    }
    return super.post(`Records?${params}`, {});
  }
}
